export default function Hero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/89f0564cfb1b6543ec7c873f5ec9a297.jpg"
          alt="Veterinarian caring for pet"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-[#0A1628]/90"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628] via-[#0A1628]/60 to-[#0A1628]/80"></div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-[#4DB8D4]/10 rounded-full blur-3xl pointer-events-none"></div>

      {/* Content */}
      <div className="relative w-full max-w-5xl mx-auto px-6 lg:px-12 py-24 text-center">
        <div className="space-y-6">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-5 py-2.5 rounded-full">
            <i className="ri-heart-pulse-line text-[#4DB8D4] text-sm"></i>
            <span className="text-xs font-semibold tracking-widest uppercase text-[#7DCFE8]">
              About Vetuvia
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl lg:text-7xl font-serif leading-[1.1] text-white max-w-4xl mx-auto" style={{textShadow: '0 2px 20px rgba(0,0,0,0.6)'}}>
            We Honor<br />
            <span className="text-[#4DB8D4] italic">Great Veterinarians</span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-xl mx-auto font-light" style={{textShadow: '0 2px 12px rgba(0,0,0,0.6)'}}>
            At Vetuvia, we believe great veterinarians make the world better.
          </p>

          {/* Decorative divider */}
          <div className="flex items-center justify-center gap-3 pt-4">
            <div className="w-12 h-px bg-[#4DB8D4]/50"></div>
            <div className="w-2 h-2 rounded-full bg-[#4DB8D4]"></div>
            <div className="w-12 h-px bg-[#4DB8D4]/50"></div>
          </div>
        </div>
      </div>
    </section>
  );
}